module.exports = __webpack_public_path__ + "img/1517668871.50b26629.jpg";